// Menu
export const TOGGLE_MENU = "TOGGLE_MENU";

// Dark Mode
export const TOGGLE_DARK_MODE = "TOGGLE_DARK_MODE";

// RTL
export const TOGGLE_RTL = "TOGGLE_RTL";

// Branded Menu
export const TOGGLE_BRANDED_MENU = "TOGGLE_BRANDED_MENU";

// Menu
export const SWITCH_MENU_TYPE = "SWITCH_MENU_TYPE";

// Theme
export const SWITCH_THEME = "SWITCH_THEME";

// Gray
export const SWITCH_GRAY = "SWITCH_GRAY";

// Fonts
export const SWITCH_FONTS = "SWITCH_FONTS";
